import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { BrandService } from 'brand';
import { SvgComponent } from 'icon';

@Component({
  imports: [SvgComponent],
  template: `
    <div
      class="flex items-center mb-2 [&_*]:font-normal [&_*]:!mb-0 [&_*]:text-base [&_strong]:font-bold text-[--color-text-primary]"
    >
      <div class="pr-1.5">
        <lib-svg [svg]="'check-indicator-' + brand" />
      </div>
      <div>
        <ng-content />
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrismicCheckmarkComponent {
  public brand = inject(BrandService).brand;
}
